import { createSlice } from "@reduxjs/toolkit";
import { cloneCytoscapeValue } from '../../../helpers/cytoscapeElements';

const selectedTransactionSlice = createSlice({
  name: 'selectedTransaction',
  initialState: {
    transactionId: '',
    transactionData: null,
  },
  reducers: {
    updateSelectedTransaction: (state, action) => {
      state.transactionId = action.payload.transactionId;
      state.transactionData = action.payload.transactionData == null
        ? null
        : cloneCytoscapeValue(action.payload.transactionData);
    },
    clearSelectedTransaction: (state) => {
      state.transactionId = '';
      state.transactionData = null;
    }
  }
});

export const { updateSelectedTransaction, clearSelectedTransaction } = selectedTransactionSlice.actions;
export default selectedTransactionSlice.reducer;
